import * as React from 'react';
import s from '../CheckoutPage.scss';
import { withTranslation, WithTranslation } from 'react-i18next';
import { withInjectedRootStore, RootStore } from 'providers';
import { Text, InfoIcon } from 'wix-style-react';
import { creditExplanationTooltipData } from '../../../utils';
import { usePremiumCurrencyFormatter } from '@wix/premium-react-text';
import { useDelayedTooltipBiEvent } from '../../../hooks/useDelayedTooltipBiEvent';

export interface CreditExplanationProps extends WithTranslation {
  rootStore: RootStore;
}
const CreditExplanationComp: React.FC<CreditExplanationProps> = ({
  t,
  rootStore,
}) => {
  const {
    currentPlanDetails,
    availableCredit,
    biLogger,
    siteGuid,
  } = rootStore.appStore.appContext;

  const [currencyToString] = usePremiumCurrencyFormatter();

  const onTooltipViewed = () =>
    biLogger.logCheckoutPageViewTooltipBiEvent({
      siteGuid,
      tooltipName: 'how-credit-calculated-tooltip',
    });

  const {
    logShowTooltipDelayedEvent,
    interuptTooltipDelayedEvent,
  } = useDelayedTooltipBiEvent(onTooltipViewed);

  const getCreditTooltipContent = () => {
    let content = '';
    if (currentPlanDetails && availableCredit) {
      const { daysLeft, credit } = creditExplanationTooltipData(
        currentPlanDetails,
        availableCredit,
      );
      content = t('Advanced_Plans.second_upgrade.credit_explanation.tooltip', {
        count: daysLeft,
        credit: currencyToString(credit),
      });
    }
    return content;
  };

  return (
    <div data-hook='credit-explanation' className={s.creditDisclaimerContainer}>
      <Text dataHook='credit-explanation'>
        {t('Advanced_Second_Upgrade_Credit_Explanation')}
      </Text>
      <InfoIcon
        dataHook='credit-explanation-info'
        size='small'
        className={s.tooltip}
        content={getCreditTooltipContent()}
        tooltipProps={{
          maxWidth: 300,
          onShow: logShowTooltipDelayedEvent,
          onHide: interuptTooltipDelayedEvent,
        }}
      />
    </div>
  );
};

export const CreditExplanation = withInjectedRootStore(
  withTranslation()(CreditExplanationComp),
);
